/* eslint-disable no-param-reassign */
import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  GeoPaymentMethodList,
  GetGeoPaymentMethodListRequestPayload,
} from '@/models/ps-management/ps-management.model';

export default class GetGeoPaymentMethodListRequest extends ApiResourceMethod<GeoPaymentMethodList> {
  public perform(requestPayload: GetGeoPaymentMethodListRequestPayload): Promise<GeoPaymentMethodList> {
    return this.performer.requestWithMapper(
      {
        // для переезда на новую ручку удалить раскомментировать строку ниже
        url: `${requestPayload.countryCode}`,
        params: requestPayload.params,
      },
      (payload: BaseResponse<GeoPaymentMethodList>) => {
        // payload.data.map((item) => {
        //   // это моки, удалить перед тестированием
        //   item.type = Math.random() > 0.5 ? 'multi' : 'single';
        //   if (item.type === 'multi') {
        //     item.currencyList = ['TYR', 'NGR', 'PES', 'GBP', 'USD', 'EUR', 'RUB'];
        //     item.multiMethodId = item.billingPaymentMethodId;
        //     delete item.billingPaymentMethodId;
        //   } else {
        //     item.currency = ['USD', 'EUR', 'RUB'][Math.floor(Math.random() * 3)];
        //   }

        //   return item;
        // });

        return payload.data;
      },
    );
  }
}
